<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="handleAddClick">添加币种介绍</el-button>
    <el-dialog title="添加币种介绍" width="1200px" :visible.sync="dialogVisible" @close="closeDialog">
      <el-form
          label-width="200px"
          :model="introductionDetail"
          :rules="rules"
          ref="currencyIntroductionForm"
      >

        <el-tabs v-model="defaultTab" type="card">
          <el-tab-pane
              key="introductionDetail"
              label="币种介绍"
              name="introductionDetail"
          >
            <el-form-item label="币类型：" prop="coinBlock">
              <el-select :value="introductionDetail.coinBlock" @change="coinBlockChange">
                <el-option :key="0" :value="0" label="主币"></el-option>
                <el-option :key="1" :value="1" label="RWA币"></el-option>
                <el-option :key="2" :value="2" label="股票RWA"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="币种名称：" prop="coinName">
              <el-input :value="introductionDetail.coinName" @input="handleChange('coinName', $event)"></el-input>
            </el-form-item>
            <el-form-item label="币种：" prop="coin">
              <el-input v-model="introductionDetail.coin"></el-input>
            </el-form-item>
            <el-form-item label="币种代码：" prop="coinCode">
              <el-input v-model="introductionDetail.coinCode"></el-input>
            </el-form-item>
            <el-form-item label="币种类型：" prop="coinType">
              <el-input v-model="introductionDetail.coinType"></el-input>
            </el-form-item>
            <el-form-item label="发行价：" prop="issuePrice">
              <el-input v-model="introductionDetail.issuePrice"></el-input>
            </el-form-item>
            <el-form-item label="币总量：" prop="totalSupply">
              <el-input v-model="introductionDetail.totalSupply"></el-input>
            </el-form-item>
            <el-form-item label="流通量：" prop="availableSupply">
              <el-input v-model="introductionDetail.availableSupply"></el-input>
            </el-form-item>
            <el-form-item label="流通市值：" prop="marketValue">
              <el-input v-model="introductionDetail.marketValue"></el-input>
            </el-form-item>
            <el-form-item label="发行日期：" prop="issueDate">
              <el-date-picker
                  v-model="introductionDetail.issueDate"
                  type="date"
                  placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="共识机制：" prop="mechanism">
              <el-input v-model="introductionDetail.mechanism"></el-input>
            </el-form-item>
            <el-form-item label="区块浏览器：" prop="blockLink">
              <el-input v-model="introductionDetail.blockLink"></el-input>
            </el-form-item>
            <el-form-item label="项目官网：" prop="projectLink">
              <el-input v-model="introductionDetail.projectLink"></el-input>
            </el-form-item>
            <el-form-item label="Github地址：" prop="githubLink">
              <el-input v-model="introductionDetail.githubLink"></el-input>
            </el-form-item>
            <el-form-item label="白皮书：" prop="whitePaperLink">
              <el-input v-model="introductionDetail.whitePaperLink"></el-input>
            </el-form-item>
            <el-form-item label="简介：" prop="description">
              <el-tabs v-model="descriptionActiveLanguage" type="card">
                <el-tab-pane
                    v-for="lang in languages"
                    :key="lang.value"
                    :label="lang.label"
                    :name="lang.value"
                >
                  <editor
                      :value="introductionDetail.description[lang.value]"
                      @change="handleEditorChange('description', lang.value, $event)"
                  ></editor>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <!--        <el-form-item label="团队介绍：" prop="teamDescription">
                      <div v-for="lang in languages" :key="lang.value" class="introduction-editor">
                        <div class="introduction-editor-header">（{{ lang.label }}团队介绍）</div>
                        <editor v-model="introductionDetail.teamDescription[lang.value]"
                                @change="handleEditorChange('teamDescription', lang.value, $event)"
                        ></editor>
                      </div>
                    </el-form-item>-->
          </el-tab-pane>

          <el-tab-pane
              key="currencyIntroductionRwa"
              label="RWA信息"
              name="currencyIntroductionRwa"
              v-if="introductionDetail.coinBlock === 1 || introductionDetail.coinBlock === 2"
          >
        <span v-if ="introductionDetail.coinBlock === 1 || introductionDetail.coinBlock === 2">
        <el-form-item label="发行市值：" prop="marketValue">
          <el-input :value="introductionDetail.currencyIntroductionRwa.marketValue"
                     @input="handleRwaChange('marketValue', $event)"></el-input>
        </el-form-item>
        <el-form-item label="总营业收入：" prop="totalRevenue">
          <el-input :value="introductionDetail.currencyIntroductionRwa.totalRevenue"
                     @input="handleRwaChange('totalRevenue', $event)"></el-input>
        </el-form-item>

        <el-form-item label="净利润：" prop="profit">
          <el-input v-model="introductionDetail.currencyIntroductionRwa.profit"></el-input>
        </el-form-item>

        <el-form-item label="护盘资金池：" prop="fundPool">
          <el-input v-model="introductionDetail.currencyIntroductionRwa.fundPool"></el-input>
        </el-form-item>

        <el-form-item label="去年财报：" prop="whitePaperLink">
            <uploadMoulde :limitNumber="1" :value="introductionDetail.currencyIntroductionRwa.financialReportLastYear"
                          v-on:input="getLastYear($event)" ref="childUpload"></uploadMoulde>
        </el-form-item>

          <!--        <el-form-item label="上月财报：" prop="whitePaperLink">-->
          <!--            <uploadMoulde :limitNumber="1" :value="introductionDetail.currencyIntroductionRwa.financialReportLastMonth"-->
          <!--                          v-on:input="getLastMonth($event)" ref="childUpload"></uploadMoulde>-->

          <!--        </el-form-item>-->

      <el-form-item label="半年财报：" prop="financialReportHalfMonth">
        <uploadMoulde :limitNumber="1" :value="introductionDetail.currencyIntroductionRwa.financialReportHalfMonth"
                      v-on:input="getHalfMonth($event)" ref="childUpload"></uploadMoulde>
      </el-form-item>

      <el-form-item label="审计报告：" prop="auditReport">
        <uploadMoulde :limitNumber="1" :value="introductionDetail.currencyIntroductionRwa.auditReport"
                      v-on:input="getAuditReport($event)" ref="childUpload"></uploadMoulde>
      </el-form-item>

      <el-form-item label="评估报告：" prop="estimateReport">
        <uploadMoulde :limitNumber="1" :value="introductionDetail.currencyIntroductionRwa.estimateReport"
                      v-on:input="getEstimateReport($event)" ref="childUpload"></uploadMoulde>
      </el-form-item>

        <el-form-item label="行业地位：" prop="industryStatus">
          <el-select  v-model="introductionDetail.currencyIntroductionRwa.industryStatus">
            <el-option value="0" label="行业龙头"></el-option>
            <el-option value="1" label="行业独角兽"></el-option>
            <el-option value="2" label="行业领军企业"></el-option>
            <el-option value="3" label="行业优质企业"></el-option>
          </el-select>
        </el-form-item>

      <el-form-item label="股票名称：" prop="stockName">
        <el-input v-model="introductionDetail.currencyIntroductionRwa.stockName"></el-input>
      </el-form-item>

      <el-form-item label="股票代码：" prop="stockCode">
        <el-input v-model="introductionDetail.currencyIntroductionRwa.stockCode"></el-input>
      </el-form-item>

      <el-form-item label="行情访问地址：" prop="stockCode">
        <el-input v-model="introductionDetail.currencyIntroductionRwa.quotationLink"></el-input>
      </el-form-item>

        <el-form-item label="核心竞争力：" prop="competitiveness">
          <el-tabs v-model="competitivenessActiveLanguage" type="card">
          <el-tab-pane
              v-for="lang in languages"
              :key="lang.value"
              :label="lang.label"
              :name="lang.value"
          >
            <editor
                :value="introductionDetail.currencyIntroductionRwa.competitiveness[lang.value]"
                @change="handleEditorChange('competitiveness', lang.value, $event)"
            ></editor>
          </el-tab-pane>
        </el-tabs>
        </el-form-item>

        <el-form-item label="发展前景：" prop="prospects">
          <el-tabs v-model="prospectsActiveLanguage" type="card">
          <el-tab-pane
              v-for="lang in languages"
              :key="lang.value"
              :label="lang.label"
              :name="lang.value"
          >
            <editor
                :value="introductionDetail.currencyIntroductionRwa.prospects[lang.value]"
                @change="handleEditorChange('prospects', lang.value, $event)"
            ></editor>
          </el-tab-pane>
        </el-tabs>
        </el-form-item>

      <el-form-item label="VIE架构图：" prop="vieArch">
        <uploadMoulde :limitNumber="1" :value="introductionDetail.currencyIntroductionRwa.vieArch"
                      v-on:input="getVieArch($event)" ref="childUpload"></uploadMoulde>
      </el-form-item>

        <el-form-item label="股权结构：" prop="currencyIntroductionStock" :visible.sync="stockVisibleEdit">
          <el-table :data="introductionDetail.currencyIntroductionStock">
            <el-table-column label="股东图片" prop="logo"></el-table-column>
            <el-table-column label="股东" prop="name"></el-table-column>
            <el-table-column label="持股数量（万股）" prop="stockQuantity"></el-table-column>
            <el-table-column label="持股比例（%）" prop="stockPercent"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="small"
                    @click="handleStockRemove(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right">
            <el-button
                type="danger"
                icon="el-icon-add"
                size="small"
                @click="openStockDialog()">添加</el-button>
          </div>
        </el-form-item>

      <el-form-item label="股票质押：" prop="currencyIntroductionStock" :visible.sync="stackVisibleEdit">
        <el-table :data="introductionDetail.currencyIntroductionStockStack">
          <el-table-column label="融出机构" prop="name"></el-table-column>
          <el-table-column label="质押数量（万股）" prop="stackQuantity"></el-table-column>
          <el-table-column label="质押单价（$）" prop="stackPrice"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="small"
                  @click="handleStackRemove(scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right">
          <el-button
              type="danger"
              icon="el-icon-add"
              size="small"
              @click="openStackDialog()">添加</el-button>
        </div>
      </el-form-item>

        </span>
          </el-tab-pane>

          <el-tab-pane
              key="currencyIntroductionTeam"
              label="团队信息"
              name="currencyIntroductionTeam"
              v-if="introductionDetail.coinBlock === 1 || introductionDetail.coinBlock === 2"
          >


            <el-form-item label="成员：" prop="currencyIntroductionTeam">
              <el-table :data="introductionDetail.currencyIntroductionTeam">
                <el-table-column label="图标" prop="logo"></el-table-column>
                <el-table-column label="姓名" prop="name"></el-table-column>
                <el-table-column label="职务" prop="job"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        size="small"
                        @click="handleTeamRemove(scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="text-align: right">
                <el-button
                    type="danger"
                    icon="el-icon-add"
                    size="small"
                    @click="openTeamDialog()">添加
                </el-button>
              </div>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <el-dialog title="添加成员" :visible.sync="teamVisibleEdit" :append-to-body="true" width="40%" height="30%"
                 :close-on-click-modal="false">
        <div>
          <div style="margin-top: 20px">
            <span style="padding-right: 20px">上传头像:</span>
            <uploadMoulde :limitNumber="1" v-on:input="getSucessInfo" ref="childUpload"></uploadMoulde>
          </div>

          <div style="margin-top: 20px">
            <span style="padding-right: 20px">姓名:</span>
            <el-input style="width: 70%" size="small" placeholder="请输入内容" maxlength =8
                      v-model="team.name">
            </el-input>
          </div>

          <div style="margin-top: 20px">
            <span style="padding-right: 20px">职务:</span>
            <el-input style="width: 70%" size="small" placeholder="请输入内容" maxlength =8
                      v-model="team.job">
            </el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addTeam">确 定</el-button>
                <el-button @click="closeDialog">取 消</el-button>
            </span>
      </el-dialog>

      <el-dialog title="添加股东" :visible.sync="stockVisibleEdit" :append-to-body="true" width="40%" height="30%"
                 :close-on-click-modal="false">
        <div>
          <div style="margin-top: 20px">
            <span style="padding-right: 20px">上传股东图片:</span>
            <uploadMoulde :limitNumber="1" v-on:input="getStockSucessInfo" ref="childUpload"></uploadMoulde>
          </div>

          <div style="margin-top: 20px">
            <span style="padding-right: 20px">股东:</span>
            <el-input style="width: 70%" size="small" placeholder="请输入内容" maxlength=20
                      v-model="stock.name">
            </el-input>
          </div>

          <div style="margin-top: 20px">
            <span style="padding-right: 20px">持股数量（万股）:</span>
            <el-input style="width: 70%" size="small" placeholder="请输入内容" maxlength=20 type="number"
                      v-model="stock.stockQuantity">
            </el-input>
          </div>

          <div style="margin-top: 20px">
            <span style="padding-right: 20px">持股比例（%）:</span>
            <el-input style="width: 70%" size="small" placeholder="请输入内容" maxlength=20 type="number" max=100
                      v-model="stock.stockPercent">
            </el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addStock">确 定</el-button>
                <el-button @click="closeStockDialogUpdate">取 消</el-button>
            </span>
      </el-dialog>

      <el-dialog title="添加股票质押" :visible.sync="stackVisibleEdit" :append-to-body="true" width="40%" height="30%"
                 :close-on-click-modal="false">
        <div>
          <div style="margin-top: 20px">
            <span style="padding-right: 20px">融出机构:</span>
            <el-input style="width: 70%" size="small" placeholder="请输入内容" maxlength=20
                      v-model="stack.name">
            </el-input>
          </div>

          <div style="margin-top: 20px">
            <span style="padding-right: 20px">质押数量（万股）:</span>
            <el-input style="width: 70%" size="small" placeholder="请输入内容" maxlength=20
                      v-model="stack.stackQuantity">
            </el-input>
          </div>

          <div style="margin-top: 20px">
            <span style="padding-right: 20px">质押单价（$）:</span>
            <el-input style="width: 70%" size="small" placeholder="请输入内容" maxlength=20
                      v-model="stack.stackPrice">
            </el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addStack">确 定</el-button>
                <el-button @click="closeStackDialogUpdate">取 消</el-button>
            </span>
      </el-dialog>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('currencyIntroductionForm')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations} from "vuex";
import Editor from "components/editor";
import LANGUAGES from "common/languages";
import uploadMoulde from "../../../../../components/upload/indexLimit.vue";

export default {
  name: "CreateCurrencyIntroduction",
  data() {
    return {
      languages: Object.keys(LANGUAGES).map(lang => ({
        label: LANGUAGES[lang],
        value: lang
      })),
      defaultTab: 'introductionDetail',
      descriptionActiveLanguage: '',
      competitivenessActiveLanguage: '',
      prospectsActiveLanguage: '',
      dialogVisible: false,
      teamVisibleEdit:false,
      stockVisibleEdit: false,
      stackVisibleEdit: false,
      team: {
        name: "",
        job: "",
        logo: ""
      },
      stock: {
        name: "",
        job: "",
        logo: "",
        stockQuantity: 0,
        stockPercent: 0,
      },
      stack: {
        name: "",
        stackQuantity: 0,
        stackPrice: 0,
      },
      name:"",
      job:"",
      logo:"",
      rules: {
        code: [{ required: true, message: "请输入币种名称" }]
      }
    };
  },
  computed: {
    ...mapState("currencyIntroductionSetting", [
      // "dialogVisible",
      "introductionDetail"
    ])
  },
  created() {
    this.descriptionActiveLanguage = this.languages !== undefined && this.languages.length > 0 ? '' + this.languages[0].value + '' : null
    this.competitivenessActiveLanguage = this.languages !== undefined && this.languages.length > 0 ? '' + this.languages[0].value + '' : null
    this.prospectsActiveLanguage = this.languages !== undefined && this.languages.length > 0 ? '' + this.languages[0].value + '' : null
    this.introductionDetail.coinBlock = 0
  },
  components: {
    Editor,uploadMoulde
  },
  methods: {
    ...mapActions("currencyIntroductionSetting", [
      "create"
    ]),
    ...mapMutations("currencyIntroductionSetting", [
      "setIntroductionDetail",
      "toggleDetailDialogVisible"
    ]),
    handleAddClick() {
        this.dialogVisible = true;
        this.setIntroductionDetail({
            ...this.introductionDetail,
            currencyIntroductionTeam: [],
            // 修复：初始化所有必填字段
            currencyIntroductionRwa: {
                marketValue: '',
                totalRevenue: '',
                profit: '',
                fundPool: '',
                industryStatus: "0",
                competitiveness: this.initLanguageFields(),
                prospects: this.initLanguageFields(),
                ...this.introductionDetail.currencyIntroductionRwa
            }
        });
        this.defaultTab = 'introductionDetail';
    },
    // 新增：初始化多语言字段的方法
    initLanguageFields() {
      return this.languages.reduce((acc, lang) => {
        acc[lang.value] = '';
        return acc;
      }, {});
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {

          // 检查currencyIntroductionStock中的所有项目中的stockPercent总和是否大于100，大于则不能提交
          if (this.introductionDetail.currencyIntroductionStock.reduce((acc, item) => {
            return acc + item.stockPercent;
          }, 0) > 100) {
            this.$message.error("股票质押百分比总和不能大于100");
            return;
          }

          //this.introduction.description = JSON.stringify(this.introduction.description);
          //this.introduction.teamDescription = JSON.stringify(this.introduction.teamDescription);
          this.introductionDetail.currencyIntroductionRwa.competitiveness = JSON.stringify(this.introductionDetail.currencyIntroductionRwa.competitiveness);
          this.introductionDetail.currencyIntroductionRwa.prospects = JSON.stringify(this.introductionDetail.currencyIntroductionRwa.prospects);
          this.create({
            ...this.introductionDetail,
            description: JSON.stringify(this.introductionDetail.description),
            teamDescription: JSON.stringify(this.introductionDetail.teamDescription),
            competitiveness : this.introductionDetail.currencyIntroductionRwa.competitiveness,
            prospects : this.introductionDetail.currencyIntroductionRwa.prospects
          }).then(() => {
            this.$message.success("添加成功！");
            this.dialogVisible = false;
            this.$emit("refresh", { page: 1 });
          });
        }
      });
    },
    getLastYear( data) {
      //上传成功
      this.introductionDetail.currencyIntroductionRwa.financialReportLastYear = data;
      this.$forceUpdate();
    },
    getLastMonth(data) {
      //上传成功
      this.introductionDetail.currencyIntroductionRwa.financialReportLastMonth = data;
      this.$forceUpdate();
    },
    getHalfMonth(data) {
      //上传成功
      this.introductionDetail.currencyIntroductionRwa.financialReportHalfMonth = data;
      this.$forceUpdate();
    },
    getAuditReport(data) {
      //上传成功
      this.introductionDetail.currencyIntroductionRwa.auditReport = data;
      this.$forceUpdate();
    },
    getEstimateReport(data) {
      //上传成功
      this.introductionDetail.currencyIntroductionRwa.estimateReport = data;
      this.$forceUpdate();
    },
    getVieArch(data) {
      //上传成功
      this.introductionDetail.currencyIntroductionRwa.vieArch = data;
      this.$forceUpdate();
    },
    getTeamSucessInfo(data) {
      this.team.logo = data;
    },
    getStockSucessInfo(data) {
      this.stock.logo = data;
    },
    getSucessInfo(data){
      this.logo = data;
    },
    handleTeamRemove(id) {
        const newTeam = [...this.introductionDetail.currencyIntroductionTeam];
        newTeam.splice(id, 1);
        this.setIntroductionDetail({
            ...this.introductionDetail,
            currencyIntroductionTeam: newTeam
        });
    },
    handleStockRemove(id) {
        const newStock = [...this.introductionDetail.currencyIntroductionStock];
        newStock.splice(id, 1);
        this.setIntroductionDetail({
            ...this.introductionDetail,
            currencyIntroductionStock: newStock
        });
    },
    handleStackRemove(id) {
      this.introductionDetail.currencyIntroductionStockStack.splice(id, 1);
    },
    addTeam(){
        const newItem = {logo: this.team.logo, name: this.team.name, job: this.team.job};
        const newTeam = [...(this.introductionDetail.currencyIntroductionTeam || []), newItem];

        this.setIntroductionDetail({
            ...this.introductionDetail,
            currencyIntroductionTeam: newTeam
        });
        this.cancelTeam();
    },
    addStock() {
      // 基础校验，规则：股东不能为空、持股数量不能为空且只能为数字、持股比例不能为空且只能为数字
      if (!this.stock.name || !this.stock.stockQuantity || !this.stock.stockPercent) {
        this.$message.error("请填写完整！");
        return;
      }

      const newItem = {
        logo: this.stock.logo,
        name: this.stock.name,
        stockQuantity: this.stock.stockQuantity,
        stockPercent: this.stock.stockPercent
      };
      const newStock = [...(this.introductionDetail.currencyIntroductionStock || []), newItem];

      this.setIntroductionDetail({
        ...this.introductionDetail,
        currencyIntroductionStock: newStock
      });
      this.cancelStock();
    },
    addStack() {
      if (this.introductionDetail.currencyIntroductionStockStack != null) {
        this.introductionDetail.currencyIntroductionStockStack.push({name: this.stack.name, stackQuantity: this.stack.stackQuantity, stackPrice: this.stack.stackPrice});
      } else {
        this.introductionDetail.currencyIntroductionStockStack = [];
        this.introductionDetail.currencyIntroductionStockStack.push({name: this.stack.name, stackQuantity: this.stack.stackQuantity, stackPrice: this.stack.stackPrice});
      }
      this.cancelStack();
    },
    cancelStock() {
      this.stockVisibleEdit = false;
      this.stock.logo = "";
      this.stock.name = "";
      this.stock.stockQuantity = "";
      this.stock.stockPercent = "";
    },
    cancelStack() {
      this.stackVisibleEdit = false;
      this.stack.name = "";
      this.stack.stackQuantity = 0;
      this.stack.stackPrice = 0;
    },
    cancelTeam() {
      this.teamVisibleEdit = false;
      this.team.logo = "";
      this.team.name = "";
      this.team.job = "";
    },
    handleChange(key, value) {
      this.setIntroductionDetail({
        ...this.introductionDetail,
        [key]: value
      });
    },
    // 新增：处理RWA字段变更
    handleRwaChange(key, value) {
      this.setIntroductionDetail({
        ...this.introductionDetail,
        currencyIntroductionRwa: {
          ...this.introductionDetail.currencyIntroductionRwa,
          [key]: value
        }
      });
    },
    handleEditorChange(type, key, value) {
      this.setIntroductionDetail({
        ...this.introductionDetail,
        [type]: {
          ...this.introductionDetail[type],
          [key]: value
        }
      });
    },
    coinBlockChange(code){
      // 修改：通过 mutation 更新状态
      this.setIntroductionDetail({
        ...this.introductionDetail,
        coinBlock: code
      });
    },
    openTeamDialog(){
      this.teamVisibleEdit = true
    },
    closeTeamDialogUpdate() {
      this.cancelTeam();
    },
    openStockDialog() {
      this.stockVisibleEdit = true
    },
    closeStockDialogUpdate() {
      this.cancelStock();
    },
    closeStackDialogUpdate() {
      this.cancelStack();
    },
    closeDialog() {
      this.setIntroductionDetail({
        coinBlock: 0,
        description: {},
        teamDescription: {},
        currencyIntroductionRwa: {},
        currencyIntroductionTeam: [],
        currencyIntroductionStock: [],
        currencyIntroductionStockStack: [],
        defaultTab: 'introductionDetail',
      });
      this.toggleDetailDialogVisible(false);
      this.$refs["currencyIntroductionForm"].resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
</style>
